import axios from 'axios'

/**
 * 创建axios实例并配置默认项
 */
const instance = axios.create({
  baseURL: window.location.origin,
  timeout: 30000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

/**
 * 设置请求拦截器，自动添加CSRF Token
 */
instance.interceptors.request.use((config) => {
  // 自动添加CSRF Token
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
  if (token) {
    config.headers['X-CSRF-Token'] = token
  }
  return config
})

/**
 * GET 请求（查询）
 * @param {string} url - 请求地址
 * @param {object} query - 查询参数
 * @param {object} options - 其他选项
 * @returns {Promise} - 返回请求结果
 */
const get = async (url, query = {}, options = {}) => {
  const { data } = await instance.get(url, {
    params: query,
    ...options
  })
  return data
}

/**
 * POST 请求（创建）
 * @param {string} url - 请求地址
 * @param {object} data - 请求数据
 * @param {object} query - 查询参数
 * @param {object} options - 其他选项
 * @returns {Promise} - 返回请求结果
 */
const post = async (url, data = {}, query = {}, options = {}) => {
  const { data: result } = await instance.post(url, data, {
    params: query,
    ...options
  })

  return result
}

/**
 * PUT 请求（更新）
 * @param {string} url - 请求地址
 * @param {object} data - 请求数据
 * @param {object} query - 查询参数
 * @param {object} options - 其他选项
 * @returns {Promise} - 返回请求结果
 */
const put = async (url, data = {}, query = {}, options = {}) => {
  const { data: result } = await instance.put(url, data, {
    params: query,
    ...options
  })

  return result
}

/**
 * DELETE 请求（删除）
 * @param {string} url - 请求地址
 * @param {object} query - 查询参数
 * @param {object} options - 其他选项
 * @returns {Promise} - 返回请求结果
 */
const del = async (url, query = {}, options = {}) => {
  const { data: result } = await instance.delete(url, {
    params: query,
    ...options
  })

  return result
}

export { get, post, put, del }
